import { useHistory, useParams, useRouteMatch } from 'peach/router'
import { Breadcrumb, LoadingContainer, Panels, Bar } from 'peach/components'
import { getName } from 'peach/helpers'
import { Page, Clickable, ConfirmDialog, DynamicForm } from 'core/components'
import {
  useLoanTapeGet,
  useLoanTapeUpdate,
  useLoanTapeDelete,
} from 'core/types'
import { loanTapeSchema } from 'core/utils/generated/formSchemas'

const LoanTape = () => {
  const history = useHistory()
  const { url } = useRouteMatch()
  const { companyId, loanTapeId } = useParams<{
    companyId?: string
    loanTapeId?: string
  }>()

  const {
    data: loanTape,
    isLoading,
    refetch,
  } = useLoanTapeGet({
    companyId,
    loanTapeId,
    query: { untokenize: true },
  })

  const { mutateAsync: updateLoanTape } = useLoanTapeUpdate({
    companyId,
    loanTapeId,
  })

  const { mutateAsync: deleteLoanTape } = useLoanTapeDelete({
    companyId,
    loanTapeId,
  })

  const title = getName(loanTape) || 'Loan Tape'

  const onDelete = async () => {
    await deleteLoanTape()
    history.push(`/companies/${companyId}/loan-tapes`)
  }

  return (
    <Panels header={<Bar title={title} />}>
      <LoadingContainer isLoading={isLoading}>
        <Breadcrumb title={title} to={url} />
        <Page variant='full'>
          <DynamicForm
            data={loanTape || {}}
            fieldEditMode='toggle'
            omitFields={['id', 'createdAt', 'updatedAt', 'deletedAt', 'object']}
            onSubmit={async (payload: any) => {
              await updateLoanTape(payload)
              await refetch()
            }}
            otherActions={[
              <ConfirmDialog
                key='delete-action'
                onConfirm={onDelete}
                title='Delete Loan Tape'
              >
                <Clickable variant='outline'>Delete</Clickable>
              </ConfirmDialog>,
            ]}
            schema={loanTapeSchema}
          />
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default LoanTape
